import React, { useRef, useState } from 'react';
import AiSearchCompanyDetail from '../AiSearchCompanyDetail/AiSearchCompanyDetail';
import CompanyLogo from '../CompanyLogo/CompanyLogo';
import { IdentifiedProfileResponse } from '../../api/DTO/IdentifiedProfileResponse';
import { ShortlistedProfile } from '../../api/DTO/ShortlistedProfile';

const createLinkedInUrl = (companyId: string | null) => {
    if (!companyId) return null;
    return `https://www.linkedin.com/company/${companyId}`;
};

const CompanyCell = ({ profile }: IdentifiedProfileResponse | ShortlistedProfile) => {
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);

    const openCompanyDetail = () => profile.currentCompanyDomain && setOpen(true);
    const closeCompanyDetail = () => setOpen(false);

    return (
        <>
            <div
                data-cy="companyCell"
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                    e.preventDefault();
                    if (e.key === 'Enter' || e.key === ' ') {
                        openCompanyDetail();
                    }
                }}
                className={`flex max-h-8 w-full items-center gap-2.5 ${
                    profile.currentCompanyDomain ? 'cursor-pointer hover:underline' : ''
                }`}
                onClick={openCompanyDetail}
            >
                <CompanyLogo
                    companyDomain={profile.currentCompanyDomain}
                    companyName={profile.currentCompanyName}
                    size="32px"
                />
                <p
                    ref={anchorRef}
                    className="text-foreground overflow-hidden text-sm text-ellipsis"
                    style={{ textDecoration: 'inherit' }}
                >
                    {profile.currentCompanyName}
                </p>
            </div>
            {profile.currentCompanyName && (
                <AiSearchCompanyDetail
                    open={open}
                    companyName={profile.currentCompanyName}
                    companyDomain={profile.currentCompanyDomain}
                    companyLinkedInUrl={createLinkedInUrl(profile.currentCompanyCompanyId)}
                    onClose={closeCompanyDetail}
                    anchorEl={anchorRef.current}
                />
            )}
        </>
    );
};

export default CompanyCell;
